export const environment = {
  production: false,
  projectName: 'Optimal Project',
  apiUrl: 'https://web-api.dev.optimaldistributiongroup.com/api/',
  rulesEngineUrl: 'https://web-api.dev.optimaldistributiongroup.com/api/rules/',
  auth0: {
    domain: 'auth.dev.optimaldistributiongroup.com',
    clientId: 'l6lxlkslYKEHBm4KiscPHZ6Jm28cjlUy',
    redirectUri: 'https://dev.optimaldistributiongroup.com/system',
    cacheLocation: 'memory',
  },
  mode: 'development',
  apiVersion: '2.1',
  datadog: {
    applicationId: '87527482-7fbf-40a7-b55a-f50c028a4013',
    clientToken: 'pub3f8ac3c6af5dfcdebf632e9f36719f0a',
    site: 'datadoghq.com',
    env: 'dev',
    service: 'optimalapp-spa',
    sampleRate: 100,
    premiumSampleRate: 100,
    trackInteractions: true,
    trackFrustrations: true,
    defaultPrivacyLevel: 'mask-user-input',
    enableSessionReplays: true,
    allowedTracingUrls: [
      'https://web-api.dev.optimaldistributiongroup.com/api/',
    ],
  },
  featureFlags: {
    cirqueDuSoleil: true,
    accounts: true,
    workQueues: false,
    olapMode: false,
  },
};
